module.exports = __webpack_public_path__ + "chipContacts-bg.png?1374a41290c58d69fd453e2c37f13b58";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/chipContacts-bg.png
// module id = 136
// module chunks = 0